'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _inputGroup = require('./input-group');

var _inputGroup2 = _interopRequireDefault(_inputGroup);

var _actions = require('../login-component/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
    trackingEvent: _actions.trackingEvent
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_inputGroup2.default));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/input-group/Container.js
// module id = 478
// module chunks = 0